import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import useWorkflowSteps from '~/containers/viewer/explorer-sidebar/WorkflowStepper/useWorkflowSteps';
import { compareModeActiveState } from '~/state/atoms/structureSet/roiAtoms';
import {
    selectedOperationState,
    selectedToolState,
} from '~/state/atoms/toolsAtoms';

export default function WorkflowSidebarContent() {
    const setSelectedTool = useSetRecoilState(selectedToolState);
    const setSelectedOperation = useSetRecoilState(selectedOperationState);
    const setCompareModeActive = useSetRecoilState(compareModeActiveState);
    const { currentStep, workingStep } = useWorkflowSteps();

    // Contour comparison is QA tooling scoped to the Review step (activated from
    // its sidebar). Clearing it on every step change keeps the overlay + metrics
    // panel from lingering into contouring or any other workflow.
    useEffect(() => {
        setSelectedTool('pan');
        setSelectedOperation(null);
        setCompareModeActive(false);
    }, [
        workingStep,
        setSelectedTool,
        setSelectedOperation,
        setCompareModeActive,
    ]);

    const ContentComponent = currentStep.content;

    return <ContentComponent />;
}
